import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private Customer Types */
import {
  Settings,
  _CustomerBranchOfficeContact
} from '../namespace-helper'

import _ from 'lodash'

const selectedBranchOfficeContactTemplate = {
  id: 0,
  name: '',
  salution: '',
  title: '',
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  mobile: '',
  main_contact: false,
  contacts_functions_id: null,
  customers_branch_offices_id: null
}

export default {
  namespaced: true,
  state: {
    contactPersons: [],
    selectedContactPerson: _.cloneDeep(selectedBranchOfficeContactTemplate)
  },
  mutations: {
    [_CustomerBranchOfficeContact.mutations.setContactPersons] (state, payload) {
      state.contactPersons = payload
    },
    [_CustomerBranchOfficeContact.mutations.setSelectedContactPerson] (state, payload) {
      if (payload !== null) {
        state.selectedContactPerson = payload
      } else {
        state.selectedContactPerson = _.cloneDeep(selectedBranchOfficeContactTemplate)
      }
    },
    [_CustomerBranchOfficeContact.mutations.removeContactPerson] (state, payload) {
      state.contactPersons.splice(payload, 1)
    },
    [_CustomerBranchOfficeContact.mutations.addNewContactPerson] (state, payload) {
      if (state.contactPersons === null) {
        state.contactPersons = []
      }
      state.contactPersons.push(payload)
    }
  },
  actions: {
    [_CustomerBranchOfficeContact.actions.saveContactPersons] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === 0) {
          var url = API_URL + '/api/v1/customerBranchOfficeContacts'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/customerBranchOfficeContacts/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_CustomerBranchOfficeContact.actions.loadContactPersons] (context, payload) {
      console.log('loadContactPersons for branchOfficeID: ' + payload)

      var url = API_URL + '/api/v1/customerBranchOfficeContacts/branchOffice/' + payload

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_CustomerBranchOfficeContact.mutations.setContactPersons, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_CustomerBranchOfficeContact.actions.setSelectedContactPerson] ({ commit }, payload) {
      commit(_CustomerBranchOfficeContact.mutations.setSelectedContactPerson, payload)
    },
    [_CustomerBranchOfficeContact.actions.addNewContactPerson] ({ commit }, payload) {
      commit(_CustomerBranchOfficeContact.mutations.addNewContactPerson, payload)
    },
    [_CustomerBranchOfficeContact.actions.removeContactPerson] (context, payload) {
      const tempBranchOfficesContacts = context.getters.getContactPersons
      const id = tempBranchOfficesContacts[payload].id

      if (id === 0) {
        context.commit(_CustomerBranchOfficeContact.mutations.removeContactPerson, payload)
        return
      }

      var url = API_URL + '/api/v1/customerBranchOfficeContacts/' + id

      console.log('removeContactPerson: ' + id)

      store.commit(Settings.mutations.setLoading, false)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_CustomerBranchOfficeContact.mutations.removeContactPerson, payload)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_CustomerBranchOfficeContact.actions.resetState] ({ commit }, payload) {
      commit(_CustomerBranchOfficeContact.mutations.setContactPersons, [])
      commit(_CustomerBranchOfficeContact.mutations.setSelectedContactPerson, null)
    }

  },
  getters: {
    [_CustomerBranchOfficeContact.getters.getContactPersons] (state) {
      return state.contactPersons
    },
    [_CustomerBranchOfficeContact.getters.getSelectedContactPerson] (state) {
      return state.selectedContactPerson
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Customer/customerBranchOfficesContact.js